import { render, staticRenderFns } from "./OrganizationManage.vue?vue&type=template&id=603d49d0&scoped=true"
import script from "./OrganizationManage.vue?vue&type=script&lang=js"
export * from "./OrganizationManage.vue?vue&type=script&lang=js"
import style0 from "./OrganizationManage.vue?vue&type=style&index=0&id=603d49d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "603d49d0",
  null
  
)

export default component.exports